import { defineComponent as _defineComponent } from 'vue'
import { useArbitrage } from '@/helpers/composables/useArbitrage';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppleArbitrage',
  setup(__props) {

useArbitrage();

return { __sfc: true, }
}

})